import { defineStore } from "pinia"
import CryptoJS from 'crypto-js'

export const userStore = defineStore({
    id: "user",
    state: () => ({
        password: "8c57d6814d41249466a4f0733dcdaae6dd75a1b2e1bf3a7a71ed581e7e7733bc"
    }),
    actions: {
        submitForm(plainText) {
            return this.hashPassword(plainText) === this.password;
        },
        hashPassword(password) {
            return CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);
        }
    }
})